import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import { IonicInput, IonicButton } from 'ionic-ui';
import { eye, eyeOff } from 'ionicons/icons';
import React from 'react';

type Props = Omit<React.ComponentProps<typeof IonicInput>, 'suffix' | 'type'>;

const PasswordInput = React.forwardRef<HTMLInputElement, Props>(
  (props: Props, ref) => {
    const [passwordVisible, setPasswordVisible] =
      React.useState<boolean>(false);
    const handlePassword = (e: any) => {
      e.preventDefault();
      setPasswordVisible(!passwordVisible);
    };

    const iconStyle = clsx('medium-emphasis-text size-4');
    return (
      <IonicInput
        {...props}
        ref={ref}
        value={props.value || ''}
        type={passwordVisible ? 'text' : 'password'}
        suffix={
          <IonicButton
            type="button"
            onClick={handlePassword}
            className="bg-transparent hover:bg-transparent  p-2 button-with-icon border-transparent"
          >
            {!passwordVisible && <IonIcon icon={eye} className={iconStyle} />}
            {passwordVisible && <IonIcon icon={eyeOff} className={iconStyle} />}
          </IonicButton>
        }
      />
    );
  }
);

export default React.memo(PasswordInput);
